<template>
  <div class="page-block">
    <header-bar>支払い申請</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">
        支払い申請完了
      </h3>
    </div>
    <div class="page-block__inner">
      <div class="form-complete-area">
        <div class="form-complete-area__title">
          支払い申請を受け付けました。
        </div>
        <div class="form-complete-area__lead">
          この度は、ご利用いただき、誠にありがとうございます。
        </div>
        <div
          v-if="isBtoC"
          class="form-complete-area__text">
          お問い合わせ先<br />
          <a href="mailto:support@narasu.jp"> support@narasu.jp </a>
        </div>
        <div
          v-else
          class="form-complete-area__text">
          お問い合わせ先<br />
          <a href="mailto:support@zula.jp"> support@zula.jp </a>
        </div>
        <div class="form-complete-area__text">
          また、ご記入いただきましたメールアドレスへ、自動返信の確認メールを送付しています。
          <br>万が一、自動返信メールが届かない場合は、入力いただいたメールアドレスに間違いがあった可能性がございます。
          <br>メールアドレスをご確認の上、もう一度フォームよりお問い合わせ頂けますようお願い申し上げます。
        </div>
      </div>
      <div class="form-btn-area">
        <router-link
          :to="{ name: 'index' }"
          class="c-btn c-btn--back">
          トップに戻る
          <span class="c-btn__icon-arrow"></span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'

export default {
  name: 'PaymentComplete',
  components: { HeaderBar },
}
</script>
